import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import * as styles from './styles';
import { Box } from '@rebass/grid';
// Components
import InternalHeader from '../components/InternalHeader/InternalHeader';
import IncludedServicesInInvoice from './components/IncludedServicesInInvoice/IncludedServicesInInvoice';
import InvoiceTable from './components/ServicesTable/InvoiceTable';
import WarningLeavePageModal from './components/WarningLeavePageModal/WarningLeavePageModal';
// Styles
import * as invoiceActions from './reducer/invoiceActions';

class CreateInvoice extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
      warningModalIsOpen: false
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    const {
      match: { params },
      invoiceActions
    } = this.props;
    invoiceActions.loadAndSetInvoice(params.appointmentId);
  }

  componentDidUpdate() {
    const {
      invoice: { currentServices, activeServices, currentInvoice },
      invoiceActions
    } = this.props;

    if (
      !currentServices &&
      currentInvoice &&
      Array.isArray(currentInvoice.invoiceItems) &&
      Array.isArray(activeServices) &&
      currentInvoice.invoiceItems.length === activeServices.length
    ) {
      invoiceActions.loadAndSetServices(currentInvoice.practitioner.id);
    }

    if (Array.isArray(activeServices) && activeServices.length) {
      window.onbeforeunload = e => {
        let dialogText = this.props.i18n.t('go_back_text');
        e.returnValue = dialogText;
        return dialogText;
      };
    } else {
      window.onbeforeunload = null;
    }
  }

  componentWillUnmount() {
    const { invoiceActions } = this.props;
    invoiceActions.clearInvoice();
    window.onbeforeunload = null;
  }
  openModal() {
    this.setState({ warningModalIsOpen: true });
  }

  closeModal() {
    this.setState({ warningModalIsOpen: false });
  }

  render() {
    const {
      i18n,
      invoice,
      history,
      match: { params },
      invoiceActions
    } = this.props;

    const activeServicesList = invoice.activeServices || [];
    const lang = i18n && i18n.language;

    return (
      <Fragment>
        <InternalHeader />
        <styles.Container>
          <styles.BreadCrumps>
            <Link
              style={{ display: 'table-cell' }}
              onClick={e => {
                e.preventDefault();
                if (activeServicesList.length) {
                  this.openModal();
                  return;
                }
                history.goBack();
              }}
              to=""
            >
              <styles.ArrowBackImg />
            </Link>
            <styles.CommonDiv size={2.25} align="left">
              {i18n.t('create_invoice')}
            </styles.CommonDiv>
          </styles.BreadCrumps>

          <styles.ContentWrapper>
            <Box width={3 / 4} mr="30px">
              <InvoiceTable
                key={`invoice-table-${lang}`}
                i18n={i18n}
                list={invoice.currentServices || []}
                addActiveService={invoiceActions.addActiveService}
                removeActiveService={invoiceActions.removeActiveService}
                activeServicesList={activeServicesList}
              />
            </Box>

            <Box width={1 / 4}>
              <IncludedServicesInInvoice key={`included-${lang}`} i18n={i18n} params={params} />
            </Box>
          </styles.ContentWrapper>
        </styles.Container>
        {/* ──── Modals ──────────────────────────────────────────────────────────────────────── */}

        <WarningLeavePageModal
          i18n={i18n}
          isOpen={this.state.warningModalIsOpen}
          closeModal={this.closeModal}
          goBack={history.goBack}
        />
      </Fragment>
    );
  }
}

const mapStateTotProps = state => ({
  invoice: state.practitioner.invoice
});

const mapDispatchToProps = dispatch => ({
  invoiceActions: bindActionCreators(invoiceActions, dispatch)
});

export default connect(
  mapStateTotProps,
  mapDispatchToProps
)(translate()(CreateInvoice));
